import React from 'react';
import UseTouches from './use-touches';
import { autobind } from 'core-decorators';
import css from '../../utils/css';

let classes = css`
  .titulo {
    font-size: 14px;
    -ms-transform: rotate(-60deg); /* IE 9 */
    -webkit-transform: rotate(-60deg); /* Chrome, Safari, Opera */
    transform: rotate(-60deg);
    margin-left: 5px;
  }
`;

@autobind
class SliderHandle extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hover: false,
    };
  }

  hoverIn() {
    this.setState({
      hover: true,
    });
  }

  hoverOut() {
    this.setState({
      hover: false,
    });
  }

  render() {
    let props = this.props;
    let active = props.active;
    let x = props.x;
    let y = props.y;
    let size = props.size;
    let color = props.color;
    let value = props.value;
    let events = {
      ...(UseTouches()
        ? {}
        : {
            onMouseEnter: this.hoverIn,
            onMouseLeave: this.hoverOut,
          }),
      ...props.events,
    };
    let style = {
      cursor: active ? 'ew-resize' : 'pointer',
      WebkitTapHighlightColor: 'rgba(0,0,0,0)',
    };

    return (
      <g style={style} {...events}>
        <foreignObject
          className="node"
          x={x - 12}
          y={y - 40}
          width="30"
          height="15"
        >
          <div className={classes.titulo}>{value}%</div>
        </foreignObject>
        <circle ref="target" key="2" cx={x} cy={y} r={size} fill={color} />
      </g>
    );
  }
}

export default SliderHandle;
